import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './AmexPlatinumNightsHeader.scss';

const AmexPlatinumNightsHeader = (
  {
    Analytics,
    headerConfig: {
      links = [],
    },
    hideFAQs,
    matchMedia,
    hideBenefits,
    hidePlatNights,
  }
) => {
  const [isScrolled, setIsScrolled] = useState(false);
  if (links && links.length === 0) return false;
  const linksConfigWithHideSections = links
    .filter((link) => {
      const { label, url } = link;
      if (!label || !url) return false;

      switch (link?.name) {
        case 'faqs':
          return !hideFAQs && link;
        case 'platinumNightsByResy':
          return !hidePlatNights && link;
        case 'benefits':
          return !hideBenefits && link;
        default:
          return link;
      }
    });

  const onScroll = () => {
    setIsScrolled(window.scrollY > 30);
  };

  useEffect(() => {
    if (matchMedia.md) {
      window.addEventListener('scroll', onScroll);
    }
    return () => window.removeEventListener('scroll', onScroll);
  }, [matchMedia]);

  const displayCTA = (link) => {
    const { label, url } = link;
    const extraPrams = {
      action_name: 'Menu - Click',
      item_name: label,
    };

    return (
      <li
        key={label}
        className="AmexPlatinumNightsHeader__item"
      >
        <Link
          href={window?.location?.href?.split('#')[0] + url}
          className="AmexPlatinumNightsHeader__link"
          onContextMenu={() => handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraPrams)}
          onClick={() => {
            handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, extraPrams);
          }}
        >
          {label}
        </Link>
      </li>
    );
  };

  return (
    <section
      className={cx('AmexPlatinumNightsHeader', {
        scrolled: isScrolled,
      })}
    >
      <nav
        aria-label="Page links"
        className="AmexPlatinumNightsHeader__nav"
      >
        <div className="container">
          <div className="AmexPlatinumNightsHeader__wrapper">
            <ul>
              {linksConfigWithHideSections.map(displayCTA)}
            </ul>
          </div>
        </div>
      </nav>
    </section>
  );
};

AmexPlatinumNightsHeader.propTypes = {
  headerConfig: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  hideFAQs: PropTypes.bool.isRequired,
  hidePlatNights: PropTypes.bool.isRequired,
  hideBenefits: PropTypes.bool.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexPlatinumNightsHeader;
